import { IconButton, InputAdornment, Link, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useState } from 'react';

import { InputText } from 'app/components/elements/InputText';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
import { loginSchema } from 'utils/validate';
import { yupResolver } from '@hookform/resolvers/yup';
import theme from 'styles/theme';
import { TextError } from '../../../components/elements/TextError';

export type FormLoginType = {
  email: string;
  password: string;
};

type FormLoginProps = {
  onSubmit: (data: FormLoginType) => void;
  errorReturnApi?: string;
};
export const FormLogin = ({ onSubmit, errorReturnApi }: FormLoginProps) => {
  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm<FormLoginType>({ resolver: yupResolver(loginSchema) });

  const [showPassword, setShowPassword] = useState<boolean>(false);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack>
        <Stack gap={2.5}>
          <Stack gap={1}>
            <InputText
              inputError={errors.email?.message}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton>
                    <img alt={'icon-user'} src={'/icons/icon_user.svg'} width={24} />
                  </IconButton>
                </InputAdornment>
              }
              placeholder={'Email'}
              inputProps={{
                ...register('email')
              }}
            />
          </Stack>
          <Stack gap={1} mb={2}>
            <InputText
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? (
                      <Visibility sx={{ color: theme.colors.base }} />
                    ) : (
                      <VisibilityOff sx={{ color: theme.colors.base }} />
                    )}
                  </IconButton>
                </InputAdornment>
              }
              placeholder={'Password'}
              inputError={errors.password?.message}
              inputProps={{
                ...register('password'),
                type: showPassword ? 'text' : 'password'
              }}
            />
          </Stack>
        </Stack>
        <Stack alignItems={'flex-end'} mb={5.5}>
          <Link href={'/forgot-password'} sx={{ textDecoration: 'none' }}>
            Forgot Password?
          </Link>
        </Stack>
        <Stack gap={1}>
          <ButtonCustom type={'submit'} label={'Login'} />
          {errorReturnApi && <TextError errorText={errorReturnApi} />}
        </Stack>
      </Stack>
    </form>
  );
};
